module.exports = __webpack_public_path__ + "img/bg-2.de0ba291.png";